/** Backend `HtsChatRole` (#13383). */
export enum enumHtsChatMessageRole {
  Classifier = 1,
  User = 2,
}
